import { apiGet, apiPut, throwApiError } from "../utils";

export const PayoutRequestStatus = {
  Pending: "pending",
  Approved: "approved",
  Paid: "paid",
  Rejected: "rejected",
};

export const getPayoutRequests = async (
  page,
  perPage,
  search = "",
  filters = {},
) => {
  const params = { page, perPage };

  if (search) {
    params.search = search;
  }

  if (filters.status) {
    params.status = filters.status;
  }

  const response = await apiGet("/payout-requests", params);
  const { items, totalCount, message } = await response.json();

  throwApiError(message);

  return { items, totalCount };
};

export const getPayoutRequestById = async (id) => {
  const response = await apiGet(`/payout-requests/${id}`);
  const { message, ...request } = await response.json();

  throwApiError(message);

  return request;
};

export const payPayoutRequest = async (id, txid) => {
  const response = await apiPut(`/payout-requests/${id}/pay`, { txid });
  const { message, ...request } = await response.json();

  throwApiError(message);

  return request;
};

export const rejectPayoutRequest = async (id, reason) => {
  const response = await apiPut(`/payout-requests/${id}/reject`, {
    reason: reason || undefined,
  });
  const { message, ...request } = await response.json();

  throwApiError(message);

  return request;
};
